import React from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";
import restartSVG from "img/restart.svg";
import checkout2 from "img/checkout2.png";
import check from "img/check.svg";

export default function Solution({ resetData }) {
  ReactGA.pageview('/solution/2')
  return (
    <Page>
      <div className="solution-page">
        <div className="introduction-page__restart-block">
          <ul className="arrival-page__arms-list">
            <li className="full-word-s">Access</li>
            <li className="in-red">R</li>
            <li>M</li>
            <li className="full-word-s">Secure</li>
          </ul>
          <Link
            to={{ pathname: "/login", state: { prev: true } }}
            className="introduction-page__restart-btn"
            href="#"
            onClick={resetData}
          >
            <img
              className="introduction-page__restart-icon"
              src={restartSVG}
              alt=""
            />
            <span>Restart</span>
          </Link>
        </div>
        <div className="problem-page__main-section">
          <div className="problem-page__image-container">
            <img className="problem-page__image" src={checkout2} alt="" />
          </div>
          <div className="problem-page__investigate-block">
            <img className="problem-page__bang-circle" src={check} alt="" />
            <h1>Process Transactions Quickly & Efficiently</h1>
            <p>
              Calling for a head cashier adds to customer wait times, can affect
              the store’s VOC score, and ultimately result in abandoned
              transactions.
            </p>
            <p className="bold">
              The associate now knows the combination and is ready to retrieve
              the item.
            </p>
            <Link to="/problem/3" className="btn login-page__start-btn">
              <span className="white-background">To the cage</span>
            </Link>
          </div>
        </div>
      </div>
    </Page>
  );
}
